import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicVPNUserListParamsRawI,
	type LWApiPublicVPNUserListResultRawI,
} from '@liquidweb-dev/club-sauce/public/vpn/user/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const VPN_USER_LIST_QUERY_KEY = '/vpn/user/list';

const useVPNUserList = (
	params: LWApiPublicVPNUserListParamsRawI,
	options?: UseQueryOptions<LWApiPublicVPNUserListResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [VPN_USER_LIST_QUERY_KEY, params],
		queryFn: () => api.vpn.user.apiRaw.list(params),
		...options,
	});

export default useVPNUserList;
